import React from 'react';
import { View } from 'react-native';
import Spacer from 'design-system/Spacer';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import UnderReview from 'features/invest/components/UnderReview';
import useAccount from 'features/pots/hooks/useAccount';
import { OnboardingFlow } from 'utils/types/navigation';
import { UNDER_REVIEW_ACCOUNT_STATUS } from '../types';
import ProductTourComponent from './ProductTourComponent';
const Onboarding = ({ status }) => {
    const account = useAccount();
    const { paddingHorizontalStyle } = useAppFrameDimensions(true);
    if (status && UNDER_REVIEW_ACCOUNT_STATUS.includes(status)) {
        return (<View style={paddingHorizontalStyle}>
        <Spacer h={40}/>
        <UnderReview status={status} flow={OnboardingFlow.Pots} requiredUserAction={account?.kycVerification?.requiredUserAction}/>
      </View>);
    }
    return <ProductTourComponent />;
};
export default Onboarding;
